import script from "./loginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./loginPage.vue?vue&type=script&setup=true&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=5facf03c&lang=less&scoped=true"
import "./loginPage.vue?vue&type=style&index=1&id=5facf03c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5facf03c"]])

export default __exports__